import '.a{display:grid;}.ssr-plugin'
import '.ju{grid-template-columns:repeat(3, minmax(250px, 1fr));}.ssr-plugin'
import '.g{gap:1rem;}.ssr-plugin'
import { StoryCard } from '../../card/StoryCard'
import { geographyArticleLink, type GeographyPage } from '@app/util/links'
import Column from '@app/components/layout/Column'
import { Title } from '@app/components/core/typography/Title'
import { SectionHeader } from '../../sectionHeader/SectionHeader'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'
import { StoredImage } from '@app/types/StoredImage'
import { AppearItem, useAppearStyle } from '../blocks/AppearInViewport'

export type StoriesContentSectionType = {
  type: 'stories'
  title: string
  pageSlug?: string
  geographyPage?: GeographyPage
  titleLevel?: 'H1' | 'H2' | 'H3' | 'H4'
  seeMoreLabel?: string
  seeMoreLink?: string
  items: {
    id: number
    slug: string
    title: string
    intro?: string
    images?: StoredImage[]
  }[]
}

const StoryCardItem = ({
  item,
  index,
  pageSlug = '',
  geographyPage,
}: {
  item: StoriesContentSectionType['items'][number]
  index: number
  pageSlug?: string
  geographyPage?: GeographyPage
}) => {
  const appearStyle = useAppearStyle(index + 1)

  return (
    <StoryCard
      title={item.title}
      subtitle={item.intro}
      image={item.images?.[0]}
      to={geographyArticleLink(
        geographyPage,
        pageSlug,
        'verhalen',
        item.slug,
      )}
      version={index}
      style={appearStyle}
    />
  )
}

export const StoriesContentSection = ({
  title,
  pageSlug,
  geographyPage,
  titleLevel = 'H2',
  seeMoreLabel,
  seeMoreLink,
  items,
}: StoriesContentSectionType) => {
  const t = useTranslations().app

  if (items.length === 0) return null

  return (
    <Column gap="0.5rem" alignItems="stretch">
      <AppearItem staggerIndex={0}>
        {seeMoreLink ? (
          <SectionHeader
            title={title}
            titleLevel={titleLevel}
            seeMore={seeMoreLabel ?? t.common.seeMore}
            toRoute={seeMoreLink}
          />
        ) : (
          <Title.Hx title={titleLevel}>{title}</Title.Hx>
        )}
      </AppearItem>
      <styled.div className="a ju g"
        style={{
          '@media (max-width: 1200px)': {
            gridTemplateColumns: 'repeat(2, minmax(250px, 1fr))',
          },
          '@media (max-width: 800px)': {
            gridTemplateColumns: 'repeat(1, minmax(250px, 1fr))',
          },}}
      >
        {items.map((item, index) => (
          <StoryCardItem
            key={item.id}
            item={item}
            index={index}
            pageSlug={pageSlug}
            geographyPage={geographyPage}
          />
        ))}
      </styled.div>
    </Column>
  )
}
